export default __webpack_public_path__ + "static/media/Loading.ad28c7ef.gif";